// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"_Q-z","smallCardRow":"aR-z","largeCardRow":"bR-z","productSearchRow":"cR-z","curatedRow":"dR-z"};